import { SubCapabilityKey } from "@next-platform/packages-ts-types";
import { useApplicationCapabilitiesAllowed, useApplicationCapabilityReady } from "../../../infra/application/capabilities";
/**
 * Whether attaching Rulebooks is on at all for this brand/user, split per owner kind: manage plus the
 * per-owner attach sub-capability (`rulebook.characterAttach` / `rulebook.personaAttach`). The card ⋮
 * menu and the profile page share `canAttach`; the attach modal uses the per-kind flags to pick tabs.
 */
export default function useCanAttachRulebook() {
    const isManageAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookManage);
    const isCharacterAttachAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookCharacterAttach);
    const isPersonaAttachAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookPersonaAttach);
    const isCapabilityReady = useApplicationCapabilityReady();
    const canAttachCharacters = isManageAllowed && isCharacterAttachAllowed;
    const canAttachPersonas = isManageAllowed && isPersonaAttachAllowed;
    const canAttach = isCapabilityReady && (canAttachCharacters || canAttachPersonas);
    return { canAttach, canAttachCharacters, canAttachPersonas, isCapabilityReady };
}
